import { connect } from "react-redux";

const MagicCover = (props) => {
  if (props.curtainSetting === true) {
    return (
      <div className="sceneCover">
        <div className="loading-scene"> Loading 3d scene .... </div>
      </div>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state) => {
  return { curtainSetting: state.Current3dPage.curtain };
};
export default connect(mapStateToProps, {})(MagicCover);
